'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import MaterialDialog from '@mui/material/Dialog';
import { Paper } from '../Paper/Paper';
import { styled } from '@mui/material/styles';
import { ModalContext } from './ModalContext';
const StyledModal = styled(MaterialDialog)({
    '& .MuiDialog-paperFullScreen': {
        borderRadius: 0
    }
});
export const Modal = React.forwardRef(({ onClose, open, showClose = true, ...props }, ref) => (_jsx(ModalContext.Provider, { value: {
        onClose,
        showClose
    }, children: _jsx(StyledModal, { ...props, PaperComponent: Paper, onClose: onClose, open: open, ref: ref }) })));
Modal.displayName = 'Modal';
